import _ from 'lodash';

import React, { useRef, useState } from 'react';
import { Button, Drawer, message,   } from 'antd';
import type {ProDescriptionsActionType} from '@ant-design/pro-descriptions';
import ProDescriptions from '@ant-design/pro-descriptions';
import ProForm, {ProFormText, } from '@ant-design/pro-form';
import RoleSelector from "./../../../system/pages/Role/RoleSelector";
import { Role, RoleDetailProps } from './../../type/RoleType';
import RoleApi from '../../api/RoleApi';

const RoleDetail:React.FC<RoleDetailProps> = (props)=>{

    const {role, onClose, onRefresh, actionRef} = props;
    const [title, setTitle] = useState<string|undefined>(role?.name);

    return (
        <Drawer
            title={title}
            width={800}
            closable={false}
            destroyOnClose={true}
            extra={[
                <Button
                        key='closeBtn'
                        type='primary'
                        style={{backgroundColor:'red', border:0}}
                        onClick={onClose}
                >
                    关闭
                </Button>
            ]}
            {..._.omit(props, 'onRefresh', 'actionRef')}
        >
            <ProDescriptions<Role>
                column={2}
                actionRef={actionRef}
                request={async ()=>{
                    const result:Role = await RoleApi.findRoleById(role?.id||"");
                    setTitle(result?.name);

                    return {
                        success: true,
                        data: result,
                    };
                }}
                editable={{
                    onSave:async (keyPath:any, newData, oldData)=>{
                        const requestData:any = {
                            id: oldData?.id
                        };
                        let rTemp = requestData;
                        let nTemp = newData;

                        for(let i=0; i<keyPath.length; i++){
                            let field = keyPath[i];

                            if(i===keyPath.length-1){
                                rTemp[field] = nTemp[field];
                            }else{
                                rTemp[field] = {};
                                rTemp = rTemp[field];
                                nTemp = nTemp[field];
                            }
                        }

                        await RoleApi.patchEditRole(requestData);
                        actionRef?.current?.reload();
                        if(onRefresh){
                            onRefresh();
                        }
                    }
                }}
            >
                    <ProDescriptions.Item
                        dataIndex={['code']}
                        label="角色编码"
                        valueType="text"
                        copyable={false}
                        render={(dom, entity, index, action) => {
                            return (
                                <div>
                                    {dom}
                                </div>
                            );
                        }}
                        renderFormItem={() => {
                            return <RoleSelector />;
                        }}
                    />
                    <ProDescriptions.Item
                        dataIndex={['name']}
                        label="角色名称"
                        valueType="text"
                        copyable={false}
                        render={(dom, entity, index, action) => {
                            return (
                                <div>
                                    {dom}
                                </div>
                            );
                        }}
                        renderFormItem={() => {
                            return <ProFormText />;
                        }}
                    />
                    <ProDescriptions.Item
                        dataIndex={['nameAbbr']}
                        label="角色简称"
                        valueType="text"
                        copyable={false}
                        render={(dom, entity, index, action) => {
                            return (
                                <div>
                                    {dom}
                                </div>
                            );
                        }}
                        renderFormItem={() => {
                            return <ProFormText />;
                        }}
                    />
                    <ProDescriptions.Item
                        dataIndex={['nameAlias']}
                        label="角色别名"
                        valueType="text"
                        copyable={false}
                        render={(dom, entity, index, action) => {
                            return (
                                <div>
                                    {dom}
                                </div>
                            );
                        }}
                        renderFormItem={() => {
                            return <ProFormText />;
                        }}
                    />
                    <ProDescriptions.Item
                        dataIndex={['sortNo']}
                        label="显示顺序"
                        valueType="text"
                        copyable={false}
                        render={(dom, entity, index, action) => {
                            return (
                                <div>
                                    {dom}
                                </div>
                            );
                        }}
                        renderFormItem={() => {
                            return <ProFormText />;
                        }}
                    />
            </ProDescriptions>
        </Drawer>
    );
};

export default RoleDetail;